import React from 'react'
import { graphql } from 'gatsby'
import { Main } from '@leshen/ui'
import { Layout, Mappers, mapLayoutBlock } from '@leshen/gatsby-theme-sylex'

export { Head } from '@leshen/gatsby-theme-sylex'

const Business = ({ pageContext, data }) => {
  const page = pageContext.page
  const isSpanish = page?.spanish ?? false
  const packages = pageContext?.packages || {}
  const forms = pageContext?.forms || {}
  const [hero, ...sections] = page.layout

  return (
    <Layout
      page={pageContext.page}
      siteMetadata={data.site.siteMetadata}
      main={
        <Main>
          {/* Render Hero Section Block */}
          {hero &&
            mapLayoutBlock({
              block: hero,
              isSpanish,
              inHero: true,
              mappers: Mappers,
              packages,
              forms,
            })}

          <div id="loadingScrollTarget" />

          {/* Render Rest of Section Blocks */}
          {sections?.map((block) =>
            mapLayoutBlock({
              block,
              inHero: false,
              isSpanish,
              mappers: Mappers,
              packages,
              forms,
            }),
          )}
        </Main>
      }
    />
  )
}

export default Business

export const query = graphql`
  query DefaultTemplateQuery {
    site {
      ...LeshenMetadata
    }
  }
`
